import apiFetch from '../apiFetch'

export default function (processingAgencyId, token) {
  return apiFetch({ endPoint: 'PaymentMethod/' + processingAgencyId, method: 'DELETE', body: null, token: token })
}
